import { CheckCircle } from 'lucide-react';
import { styled } from 'styled-components'


const ReqSection = () => {

    const nodeColors = ['#0c4e80', '#1a6fa8', '#2e8bc7']


    const requirements = [
      {
        title: 'Background Knowledge',
        body: 'A basic understanding of the courses listed in the workshop modules section is recommended to get the most out of the workshop.',
        chips: ['Computer Simulation', 'Solar Energy', '3D Modelling', "Programming"],
        chipStyle: 'blue',
        optional: false,
      },
      {
        title: 'Notebook & Writing Materials',
        body: 'Participants are expected to bring a notebook and writing materials for personal note-taking throughout all sessions.',
        chips: ['Notebook', 'Pen / Pencil'],
        chipStyle: 'blue',
        optional: false,
      },
      {
        title: 'Personal Laptop & Storage',
        body: 'Personal laptops are required. Hard drives or flash drives may be needed to facilitate transfer of the different software used during the workshop.',
        chips: ['Laptop', 'Flash Drive', 'Hard Drive'],
        chipStyle: 'gray',
        optional: true,
      },
    ]

    return(
        <Container>
            <Timeline>
            {requirements.map((req, i) => (
                <TimelineItem key={i}>
                
                <TimelineBody $color={nodeColors[i]}>
                    <ItemTop>
                    <ItemTitle>{req.title}</ItemTitle>
                    {req.optional && <OptionalTag>Optional</OptionalTag>}
                    </ItemTop>
                    <p className="info-box-content">{req.body}</p>
                    <ChipRow>
                    {req.chips.map((chip, j) => (
                        <Chip key={j} $gray={req.chipStyle === 'gray'}>{chip}</Chip>
                    ))}
                    </ChipRow>
                </TimelineBody>
                </TimelineItem>
            ))}
            </Timeline>
        </Container>
    )
}

const Container = styled.div``

const Timeline = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  &::before {
    content: '';
    position: absolute;
    left: 17px; top: 18px; bottom: 18px;
    width: 2px;
    border-radius: 2px;
  }
`

const TimelineItem = styled.div`
  position: relative;
  padding-bottom: 2.5rem;
  &:last-child { padding-bottom: 0; }
  &:hover div[class*="TimelineNode"] { transform: scale(1.1); }
  &:hover div[class*="TimelineBody"] { box-shadow: 0 4px 18px rgba(12,78,128,0.08); }
`



const TimelineBody = styled.div`
  background: #ffffff;
  border: 0.5px solid #e5e7eb;
  border-left: 3px solid ${p => p.$color};
  border-radius: 0 10px 10px 0;
  padding: 1.1rem 1.4rem 1.25rem;
  transition: box-shadow 0.2s;
  display: flex; flex-direction: column; gap: 8px;
`

const ItemTop = styled.div`
  display: flex; align-items: center;
  justify-content: space-between; gap: 10px;
`

const ItemTitle = styled.h3`
  font-size: 15px; font-weight: 600; color: #111; line-height: 1.3;
`

const OptionalTag = styled.span`
  flex-shrink: 0;
  font-size: 10px; 
  font-weight: 600; 
  letter-spacing: 0.8px;
  text-transform: uppercase; 
  padding: 3px 9px;
  border-radius: 999px;
  background: #f3f4f6; color: #6b7280; border: 0.5px solid #e5e7eb;
`

const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 4px;
`

const Chip = styled.span`
  font-size: 11px;
  font-weight: 500;
  padding: 3px 11px;
  border-radius: 999px;
  background: ${p => p.$gray ? '#f3f4f6' : '#E6F1FB'};
  color: ${p => p.$gray ? '#4b5563' : '#0C447C'};
  border: 0.5px solid ${p => p.$gray ? '#e5e7eb' : '#B5D4F4'};
`


export default ReqSection;